import { schema } from 'normalizr';

export const tokenSchema = new schema.Entity(
  'tokens',
  {},
  {
    idAttribute: (value, parent) => `${value.address}_${parent.name}`,
    processStrategy: (value, parent) => ({
      ...value,
      networkId: parent.shortName,
    }),
  },
);
